import React, { useEffect, useState } from 'react';
import { CollapseBlock, Spinner } from '../../../../common';
import HelpTable from './HelpTable/HelpTable.jsx';
import { routes } from '../../../../../utils/helpers/ApiClient';
import { AppBarCMS } from '../../../../basic';
import { PlusSquareOutlined, QuestionCircleFilled } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  useDeleteHelpMutation, useGetHelpItemQuery,
  useGetHelpItemsQuery,
} from '../../../../../redux/services/help';
import PopupWindow from '../../../../common/modals/PopupWindow/PopupWindow.jsx';
import { isNull } from 'lodash';
import { useToastMessages } from '../../../../../hooks/useToastMessages.jsx';
import BaseHtmlModal from '../../../../common/modals/RawHtmlModal/BaseHtmlModal.jsx';
import useHelpWithModal from '../../../../../hooks/useHelpWithModal.jsx';

const HelpPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: allHelps, isLoading, refetch } = useGetHelpItemsQuery();
  const [deleteHelp, { isSuccess }] = useDeleteHelpMutation();
  const {
    deleteSuccess
  } = useToastMessages()

  useEffect(() => {
    console.log(allHelps)
  }, [allHelps]);

 /* const {
    helpDetail,
    helpActions,
    modal
  } = useHelpWithModal();*/

  useEffect(() => {
    console.log(allHelps)
  }, [allHelps]);
  const [helpPreviewId, setHelpPreviewId] = useState(null);

  useEffect(() => {
    if (isSuccess) {
      deleteSuccess()
      refetch();
    }
  }, [isSuccess, refetch]);


  return isLoading ? (
    <Spinner />
  ) : (
    <>
      <AppBarCMS
        title={t('Správa helpu')}
        backUrl={routes.cmsDashboard}
        backUrlTooltip={t('Nástenka')}
        createText={t('Pridať pomoc')}
        createUrl={routes.cmsHelpCreate}
        //mainActions={helpActions}
        permissionsBasic={'help'}
      />
      <div style={{ margin: '10px' }}>
        <CollapseBlock>
          <HelpTable
            helps={allHelps ?? []}
            onEdit={id => navigate(`${routes.cmsHelpEdit}/${id}`)}
            onDelete={record => {
              deleteHelp(record.id);
            }}
            onPreview={(record) => {
              setHelpPreviewId(record.id);
            }}
          />
        </CollapseBlock>
      </div>


      {!isNull(helpPreviewId) ? (
        <BaseHtmlModal
          visible={!isNull(helpPreviewId)}
          toggle={() => setHelpPreviewId(null)}
          content={allHelps.find(help => help.id === helpPreviewId)?.content || ''}
          headerTitle={allHelps.find(help => help.id === helpPreviewId)?.title ?? t('Pomoc')}
        />
      ) : null}


     {/* {helpDetail.data && !helpDetail.error && (
        <BaseHtmlModal
          visible={modal.props.visible}
          headerTitle={modal.props.headerTitle}
          content={modal.props.content}
          toggle={modal.props.toggle}
        />
      )}*/}
    </>
  );
};

export default HelpPage;
